<template>
  <v-app :style="'background-color:' + _backgroudcolor">
    <v-content>
      <v-layout mt-2 row wrap align-center justify-center>
        <v-flex sm4 md7 lg7 pl-5>
          <v-card class="mx-auto elevation-0" outlined color="transparent">
            <v-card-title>
              <v-avatar class="mr-3" :color="_pageDetailcolor">
                <v-icon dark>mdi-server</v-icon>
              </v-avatar>
              <b :style="'font-size: 18px; color:' + _pageDetailcolor">
                {{ $t("portaltoolbar.package_storage") }}
              </b>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex sm8 md5 lg5 text-right pr-10 v-if="$vuetify.breakpoint.smAndUp">
          <DialogTestSystem></DialogTestSystem>
        </v-flex>
        <v-flex sm8 md5 lg5 text-left px-10 v-else>
          <DialogTestSystem></DialogTestSystem>
        </v-flex>
      </v-layout>

      <v-container fluid grid-list-lg grid-list-sm grid-list-md mt-n3>
        <v-layout row wrap>
          <!-- คำนวนค่าบริการ Storage ของคุณ -->
          <v-flex
            lg12
            md12
            sm12
            xs12
            :pl-5="$vuetify.breakpoint.smAndUp"
            :pr-5="$vuetify.breakpoint.smAndUp"
            class="fill-height"
            pb-0
          >
            <!--Banner-->
            <div id="banner">
              <v-layout row wrap align-center justify-center ma-1 pa-0>
                <v-flex
                  xl3
                  lg3
                  md3
                  sm2
                  xs12
                  :ml-n12="$vuetify.breakpoint.sm"
                  class="mt-n2"
                >
                  <!--PC / IPAD-->
                  <img
                    v-if="$vuetify.breakpoint.smAndUp"
                    width="128px;"
                    :src="require('@/assets/package/storage_cloud.png')"
                  />
                </v-flex>

                <v-flex xl6 lg6 md6 sm7 xs12 :pr-10="$vuetify.breakpoint.sm">
                  <!--pc-->
                  <div
                    v-if="$vuetify.breakpoint.mdAndUp"
                    class="mt-n5 showHead"
                  >
                    <b :style="'font-size: 19px; color:' + _pageDetailcolor">
                      {{ $t("package.title_storage") }}</b
                    >
                    <b
                      :style="'font-size: 25px; color:' + _pageDetailcolor"
                      class="mx-2"
                    >
                      {{ totalStorage }}
                    </b>
                  </div>
                  <!--Ipad-->
                  <div
                    v-else-if="$vuetify.breakpoint.sm"
                    class="text-right mt-n4 mb_Sz_text"
                  >
                    <b :style="'color:' + _pageDetailcolor">
                      {{ $t("package.title") }}</b
                    >
                    <b
                      :style="'font-size: 20px; color:' + _pageDetailcolor"
                      class="mx-2"
                    >
                      {{ totalStorage }}
                    </b>
                  </div>
                  <!--Phone-->
                  <div v-else class="text-center mt-n2">
                    <b class="mb_Sz_text" :style="'color:' + _pageDetailcolor">
                      {{ $t("package.title") }}</b
                    >
                    <b
                      class="mb_Sz_text mx-2"
                      :style="'font-size: 20px; color:' + _pageDetailcolor"
                    >
                      {{ totalStorage }}
                    </b>
                  </div>
                </v-flex>
                <v-flex
                  xl3
                  lg3
                  md3
                  sm3
                  xs12
                  :ml-n12="$vuetify.breakpoint.smAndUp"
                  class="mt-n3"
                >
                  <!--pc / IPAD-->
                  <v-btn
                    v-if="$vuetify.breakpoint.smAndUp"
                    color="#f05c5a"
                    dark
                    class="elevation-0 mx-sm-n5 pl-sm-1 pr-sm-1 mx-md-n3 pa-md-5 pl-md-1 pr-md-1 mx-lg-2 mx-lx-2 btn-help float-right"
                    @click="fn_problem('support')"
                  >
                    <v-icon dark class="mr-1">mdi-alert-circle-outline</v-icon>
                    {{ $t("package.problem") }}
                  </v-btn>
                  <!--phone-->
                  <div v-else class="text-center pb-16">
                    <v-btn
                      color="#f05c5a"
                      dark
                      class="elevation-0 btn-help pl-xs-1 pr-xs-1"
                      @click="fn_problem('support')"
                    >
                      <v-icon dark class="me-1"
                        >mdi-alert-circle-outline</v-icon
                      >
                      {{ $t("package.problem") }}
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <!--Card-->
            <div id="cardPackage" class="elevation-0 mt-7" color="transparent">
              <v-layout row wrap justify-center align-center>
                <v-flex lg12 md11 sm12 xs12>
                  <div v-if="detailStorage.length !== 0">
                    <center>
                      <!--card <= 3-->
                      <v-sheet
                        v-if="detailStorage.length <= 3"
                        elevation="0"
                        color="transparent"
                        class="sheet"
                      >
                        <!--max-width="1000"-->
                        <v-slide-group
                          center-active
                          show-arrows
                          mobile-break-point="1000"
                          active-class="success"
                        >
                          <template v-slot:next>
                            <v-icon color="black" large
                              >mdi-chevron-right-circle</v-icon
                            >
                          </template>
                          <template v-slot:prev>
                            <v-icon color="black" large
                              >mdi-chevron-left-circle</v-icon
                            >
                          </template>
                          <div v-for="(item, i) in detailStorage" :key="i">
                            <v-slide-item>
                              <!--width="309" -->
                              <v-card class="ma-3 cardPackage">
                                <v-card-title
                                  v-if="
                                    i == Object.keys(detailStorage).length - 1
                                  "
                                  style="color: #609cd4; background: #f1ce1e"
                                  class="pa-2"
                                >
                                  <v-layout
                                    wrap
                                    row
                                    justify-center
                                    align-center
                                  >
                                    <v-flex xs12 lg12 class="text-center">
                                      <h3
                                        v-if="item.credit_type"
                                        style="text-transform: capitalize"
                                      >
                                        {{ item.credit_type.toUpperCase() }}
                                      </h3>
                                    </v-flex>
                                  </v-layout>
                                </v-card-title>
                                <v-card-title
                                  v-else
                                  style="color: #609cd4"
                                  class="pa-2"
                                >
                                  <v-layout
                                    wrap
                                    row
                                    justify-center
                                    align-center
                                  >
                                    <v-flex xs12 lg12 class="text-center">
                                      <h3
                                        v-if="item.credit_type"
                                        style="text-transform: capitalize"
                                      >
                                        {{ item.credit_type.toUpperCase() }}
                                      </h3>
                                    </v-flex>
                                  </v-layout>
                                </v-card-title>
                                <v-card-text class="text-center bgCard">
                                  <center>
                                    <div v-if="item.index <= 5">
                                      <img
                                        v-for="(data, i) in item.index"
                                        :key="i"
                                        class="mt-4 mx-1 star"
                                        src="@/assets/package/credit1.png"
                                      />
                                    </div>
                                    <div v-else>
                                      <img
                                        v-for="(data, i) in numStar"
                                        :key="i"
                                        class="mt-4 mx-1 star"
                                        src="@/assets/package/credit1.png"
                                      />
                                    </div>
                                  </center>
                                  <div class="line-1 mt-2 ma-1"></div>
                                  <v-layout
                                    row
                                    wrap
                                    justify-center
                                    align-center
                                    class="pa-0"
                                  >
                                    <v-flex
                                      lg12
                                      md12
                                      sm12
                                      xs12
                                      class="text-center"
                                    >
                                      <span class="white--text mb_Sz_text">
                                        {{ item.storage }} {{ item.unit }}
                                      </span>
                                    </v-flex>
                                    <!--<v-flex lg4 md4 sm4 xs4 class="text-left">
                                      <span class="white--text mb_Sz_text">
                                        {{ item.storage }}
                                      </span>
                                    </v-flex>
                                    <v-flex lg8 md8 sm8 xs8 class="text-left">
                                      <span class="white--text mb_Sz_text">
                                        {{ item.unit }}
                                      </span>
                                    </v-flex>-->
                                  </v-layout>
                                  <div class="line-1 mt-2 ma-1"></div>
                                  <div
                                    v-if="
                                      i == Object.keys(detailStorage).length - 1
                                    "
                                    class="logoPackage white--text"
                                  >
                                    {{ $t("package.recommend") }}
                                  </div>
                                  <div v-else class="noLogo"></div>
                                  <v-layout
                                    row
                                    wrap
                                    justify-center
                                    align-center
                                    class="mt-n4"
                                  >
                                    <v-flex
                                      lg12
                                      md12
                                      sm12
                                      xs12
                                      class="text-center"
                                    >
                                      <span
                                        class="white--text mb_Sz_text_detail"
                                        >{{ $t("package.text9") }}
                                        <span
                                          class="font-weight-bold detailStorage"
                                          >{{ item.storage_expiry }}</span
                                        >
                                        {{ $t("package.text7") }}
                                      </span>
                                      <br />
                                      <span
                                        class="white--text mb_Sz_text_detail"
                                      >
                                        {{ $t("package.text10") }}
                                      </span>
                                    </v-flex>
                                  </v-layout>
                                  <div class="line-1 mt-2 ma-1"></div>
                                  <v-layout
                                    row
                                    wrap
                                    justify-center
                                    align-center
                                    class="mt-3 pb-1"
                                  >
                                    <v-flex
                                      lg12
                                      md12
                                      sm12
                                      xs12
                                      class="text-left"
                                    >
                                      <v-btn
                                        v-if="
                                          i ==
                                          Object.keys(detailStorage).length - 1
                                        "
                                        block
                                        color="#f1ce1e"
                                        style="
                                          height: 50px;
                                          border-radius: 15px;
                                        "
                                        class="elevation-0"
                                        @click="fn_buyPackage(item)"
                                      >
                                        <h2
                                          :style="'color:' + _pageDetailcolor"
                                        >
                                          {{ item.price }}
                                          {{ $t("package.unit") }}
                                        </h2>
                                      </v-btn>
                                      <v-btn
                                        v-else
                                        block
                                        color="#ffffff"
                                        style="
                                          height: 50px;
                                          border-radius: 15px;
                                        "
                                        class="elevation-0"
                                        @click="fn_buyPackage(item)"
                                      >
                                        <h2
                                          :style="'color:' + _pageDetailcolor"
                                        >
                                          {{ item.price }}
                                          {{ $t("package.unit") }}
                                        </h2>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-slide-item>
                          </div>
                        </v-slide-group>
                      </v-sheet>
                      <!--card > 4-->
                      <v-sheet
                        v-else
                        elevation="0"
                        color="transparent"
                        class="sheetMore"
                      >
                        <!--max-width="1500"-->
                        <v-slide-group
                          center-active
                          show-arrows
                          mobile-break-point="1000"
                          active-class="success"
                        >
                          <template v-slot:next>
                            <v-icon color="black" large
                              >mdi-chevron-right-circle</v-icon
                            >
                          </template>
                          <template v-slot:prev>
                            <v-icon color="black" large
                              >mdi-chevron-left-circle</v-icon
                            >
                          </template>
                          <div v-for="(item, i) in detailStorage" :key="i">
                            <v-slide-item>
                              <!--width="309" -->
                              <v-card class="ma-3 cardPackage">
                                <v-card-title
                                  v-if="
                                    i == Object.keys(detailStorage).length - 1
                                  "
                                  style="color: #609cd4; background: #f1ce1e"
                                  class="pa-2"
                                >
                                  <v-layout
                                    wrap
                                    row
                                    justify-center
                                    align-center
                                  >
                                    <v-flex xs12 lg12 class="text-center">
                                      <h3
                                        v-if="item.credit_type"
                                        style="text-transform: capitalize"
                                      >
                                        {{ item.credit_type.toUpperCase() }}
                                      </h3>
                                    </v-flex>
                                  </v-layout>
                                </v-card-title>
                                <v-card-title
                                  v-else
                                  style="color: #609cd4"
                                  class="pa-2"
                                >
                                  <v-layout
                                    wrap
                                    row
                                    justify-center
                                    align-center
                                  >
                                    <v-flex xs12 lg12 class="text-center">
                                      <h3
                                        v-if="item.credit_type"
                                        style="text-transform: capitalize"
                                      >
                                        {{ item.credit_type.toUpperCase() }}
                                      </h3>
                                    </v-flex>
                                  </v-layout>
                                </v-card-title>
                                <v-card-text class="text-center bgCard">
                                  <center>
                                    <div v-if="item.index <= 5">
                                      <img
                                        v-for="(data, i) in item.index"
                                        :key="i"
                                        class="mt-4 mx-1 star"
                                        src="@/assets/package/credit1.png"
                                      />
                                    </div>
                                    <div v-else>
                                      <img
                                        v-for="(data, i) in numStar"
                                        :key="i"
                                        class="mt-4 mx-1 star"
                                        src="@/assets/package/credit1.png"
                                      />
                                    </div>
                                  </center>
                                  <div class="line-1 mt-2 ma-1"></div>
                                  <v-layout
                                    row
                                    wrap
                                    justify-center
                                    align-center
                                    class="pa-0"
                                  >
                                    <v-flex
                                      lg12
                                      md12
                                      sm12
                                      xs12
                                      class="text-center"
                                    >
                                      <span class="white--text mb_Sz_text">
                                        {{ item.storage }} {{ item.unit }}
                                      </span>
                                    </v-flex>
                                    <!--<v-flex lg4 md4 sm4 xs4 class="text-left">
                                      <span class="white--text mb_Sz_text">
                                        {{ item.storage }}
                                      </span>
                                    </v-flex>
                                    <v-flex lg8 md8 sm8 xs8 class="text-left">
                                      <span class="white--text mb_Sz_text">
                                        {{ item.unit }}
                                      </span>
                                    </v-flex>-->
                                  </v-layout>
                                  <div class="line-1 mt-2 ma-1"></div>
                                  <div
                                    v-if="
                                      i == Object.keys(detailStorage).length - 1
                                    "
                                    class="logoPackage white--text"
                                  >
                                    {{ $t("package.recommend") }}
                                  </div>
                                  <div v-else class="noLogo"></div>
                                  <v-layout
                                    row
                                    wrap
                                    justify-center
                                    align-center
                                    class="mt-n4"
                                  >
                                    <v-flex
                                      lg12
                                      md12
                                      sm12
                                      xs12
                                      class="text-center"
                                    >
                                      <span
                                        class="white--text mb_Sz_text_detail"
                                        >{{ $t("package.text9") }}
                                        <span
                                          class="font-weight-bold detailStorage"
                                          >{{ item.storage_expiry }}</span
                                        >
                                        {{ $t("package.text7") }}
                                      </span>
                                      <br />
                                      <span
                                        class="white--text mb_Sz_text_detail"
                                      >
                                        {{ $t("package.text10") }}
                                      </span>
                                    </v-flex>
                                  </v-layout>
                                  <div class="line-1 mt-2 ma-1"></div>
                                  <v-layout
                                    row
                                    wrap
                                    justify-center
                                    align-center
                                    class="mt-3 pb-1"
                                  >
                                    <v-flex
                                      lg12
                                      md12
                                      sm12
                                      xs12
                                      class="text-left"
                                    >
                                      <v-btn
                                        v-if="
                                          i ==
                                          Object.keys(detailStorage).length - 1
                                        "
                                        block
                                        color="#f1ce1e"
                                        style="
                                          height: 50px;
                                          border-radius: 15px;
                                        "
                                        class="elevation-0"
                                        @click="fn_buyPackage(item)"
                                      >
                                        <h2
                                          :style="'color:' + _pageDetailcolor"
                                        >
                                          {{ item.price }}
                                          {{ $t("package.unit") }}
                                        </h2>
                                      </v-btn>
                                      <v-btn
                                        v-else
                                        block
                                        color="#ffffff"
                                        style="
                                          height: 50px;
                                          border-radius: 15px;
                                        "
                                        class="elevation-0"
                                        @click="fn_buyPackage(item)"
                                      >
                                        <h2
                                          :style="'color:' + _pageDetailcolor"
                                        >
                                          {{ item.price }}
                                          {{ $t("package.unit") }}
                                        </h2>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-slide-item>
                          </div>
                        </v-slide-group>
                      </v-sheet>
                    </center>
                  </div>
                  <div v-else style="text-align: center">
                    <img
                      class="mx-auto"
                      width="25%"
                      :src="require('@/assets/img/Nodata.png')"
                    />
                    <h2 class="text-center">
                      {{ $t("package.noData") }}
                    </h2>
                    <br />
                  </div>
                  <v-layout row wrap justify-center align-center class="mt-5">
                    <v-flex xl3 lg5 md5 sm6 xs10>
                      <div
                        color="#f05c5a"
                        class="pt-1 btnContact"
                        @click="fn_problem('sales')"
                      >
                        <h2>{{ $t("package.contact_sales") }}</h2>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center class="mt-1">
                    <v-flex xl2 lg1 md1 sm1 xs0></v-flex>
                    <v-flex xl5 lg5 md5 sm7 xs11 class="text-left">
                      <ul style="font-size: 16px; color: #f05c5a">
                        <li>
                          <b>{{ $t("package.remark3") }}</b>
                        </li>
                      </ul>
                    </v-flex>
                  </v-layout>
                  <br />
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogBuyStorage
        :show="DialogBuyStorage"
        :item="payload"
        @close="DialogBuyStorage = false"
        @getStorage="fn_getStorage()"
      />
      <DialogProblem
        :show="dialogProblem"
        :sellerId="seller_id"
        :userCode="usercode"
        :taxId="_taxId"
        :emailProblem="emailProblem"
        :topicProblem="topicProblem"
        :telProblem="telProblem"
        :type="typeProblem"
        @close="dialogProblem = false"
      />
      <!-- สถานะกำลังโหลดข้อมูล -->
      <div v-if="loadingData">
        <OverlaySearch />
      </div>
      <v-form
        ref="submitpay"
        :action="prepaiddetail.link"
        method="get"
        target="_blank"
      >
        <input
          type="hidden"
          name="authorization"
          :value="prepaiddetail.token"
        />
      </v-form>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import authorization from "@/authorization/authorization.js";
import DialogTestSystem from "@/components/portal/dialog/dialog-test-system";
import etaxJson from "@/variable/etaxJson/packageText";
import DialogProblem from "@/components/portal/dialog/package/dialog-problem.vue";
import DialogBuyStorage from "@/components/portal/dialog/package/dialog-buyStorage.vue";
import OverlaySearch from "@/components/portal/dialog/portal-overlay-search";
import swal from "sweetalert";
import swal2 from "sweetalert2";

export default {
  name: "portal-storage",
  data: () => ({
    // Old
    total: 3,
    numCredit: 1,
    checkBt: false,
    detailStorage: [],
    count: 2,
    page: 1,
    size: 50,
    boughtPackage: false,
    amountTransactions: 0,
    amountPackage: 0,
    amountCredit: 0,
    totalStorage: 0,
    valueTransactions: 0,
    loadingData: false,
    prepaiddetail: {
      link: "",
      token: "",
    },
    showLink: false,
    jsonSign: null,
    creditPerTrans: 3,
    showData: false,
    numTran: 0,
    code: "",
    errUseCode: false,
    loadingCode: false,
    snackbar: false,
    showBtn: true,
    dialogProblem: false,
    DialogBuyStorage: false,
    seller_id: "",
    usercode: "",
    emailProblem: "",
    telProblem: "",
    topicProblem: "",
    payload: {},
    typeProblem: "",
    numStar: 5,
  }),
  components: {
    DialogTestSystem,
    OverlaySearch,
    DialogProblem,
    DialogBuyStorage,
  },
  mounted() {
    this.loadingData = true;
    this.fn_getStorage();
    this.jsonSign = etaxJson;
  },
  methods: {
    // Problem
    fn_problem(data) {
      this.dialogProblem = true;
      this.usercode = localStorage.etax_username;
      if (data === "support") {
        this.typeProblem = data;
        this.emailProblem = "support@etax.one.th";
        this.telProblem = this._telProblem;
        this.topicProblem = this.$t("package.swal.toppic_problem_support");
      } else {
        // Sale
        this.typeProblem = data;
        this.emailProblem = "sales@oeb.co.th";
        this.telProblem = this._telProblem;
        this.topicProblem = this.$t("package.swal.problem_sale");
      }
    },
    // Get All Pagkege
    async fn_getStorage() {
      var payload = {
        seller_id: localStorage.etax_sellerid,
        taxid: this._taxId,
        type: "storage",
      };
      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(this._taxId);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_SERVICE_PACKAGE_API + "templates/find",
          { data: dataEncode },
          { headers }
        )
        .then((response) => {
          console.log(response);
          this.loadingData = false;
          if (response.status === 200) {
            this.detailStorage = response.data.data;
            if (this.detailStorage.length == 0) {
              this.showData = true;
            }
            // Transactions จากมาก -> น้อย
            this.detailStorage = this.detailStorage.sort((a, b) =>
              a.price > b.price ? 1 : -1
            );
            var index = 0;
            for (const item of this.detailStorage) {
              index += 1;
              item.index = index;
              item.price =
                item.price === 0 || item.price === null
                  ? 0
                  : item.price.toLocaleString();
              item.oldStorage =
                item.storage !== "" ? item.storage.split(" ") : "-";
              item.storage = item.oldStorage[0];
              item.unit = item.oldStorage[1];
            }
            this.fn_getRemainingCredit();
          }
        })
        .catch((error) => {
          this.loadingData = false;
          swal({
            title: this.$t("package.swal.errorTitle"),
            text: this.$t("package.swal.errorText"),
            icon: "error",
          });
        });
    },
    // Get All Remaining Credit
    async fn_getRemainingCredit() {
      var payload = {
        seller_id: localStorage.etax_sellerid,
        taxid: this._taxId,
      };
      // EncodeData New No Header
      var dataEncode = await authorization.encodeDataNew(payload);
      this.axios
        .post(
          process.env.VUE_APP_SERVICE_PACKAGE_API + "users/remaining-credit",
          { Data: dataEncode }
        )
        .then((response) => {
          if (response.data.status === "OK") {
            this.totalStorage = response.data.data.remaining_storage;
          } else {
            swal({
              title: this.$t("package.swal.errorTitle"),
              text: this.$t("package.swal.errorText"),
              icon: "error",
            });
          }
        })
        .catch((error) => {
          swal({
            title: this.$t("package.swal.errorTitle"),
            text: this.$t("package.swal.errorText"),
            icon: "error",
          });
        });
    },
    // Post Package
    fn_buyPackage(data) {
      this.DialogBuyStorage = true;
      this.payload = {
        taxid: this._taxId,
        seller_id: localStorage.etax_sellerid,
        updated_by: localStorage.etax_username,
        package_id: data.package_id,
        purchase_credit: data.credit_quantity || 0,
        price: data.price,
        name: data.package_name,
        package_type: data.package_type,
        storage: data.storage.toString() +" "+ data.unit.toString(),
        credit_quantity: data.credit_quantity
      };
    },
  },
  watch: {
    model(val) {
      val = null;
    },
    code(val) {
      //console.log('code ::', val);
      if (val === null || val === "") {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },
  },
  computed: {
    ...mapGetters([
      "getter_dataBusiness_profile",
      "getter_dataBusiness_profile",
    ]),
    ...mapState(["backgroudcolor", "pageDetailcolor"]),
    // Header Table
    headers() {
      return [
        {
          text: this.$t("package.table.no"),
          value: "index",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("package.table.package_name"),
          value: "package_name",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("package.table.transactions"),
          value: "credit_quantity",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("package.table.price_trans"),
          value: "price_per_trans",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("package.table.price"),
          value: "price",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("package.table.exceed_ca"),
          value: "exceed_ca",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("package.table.actions"),
          value: "actions",
          align: "center",
          sortable: false,
          class: "black--text",
        },
      ];
    },
    // pageCount
    pageCount: {
      get() {
        const l = this.detailStorage.length;
        const s = this.size;
        return Math.ceil(l / s);
      },
      set(numPage) {
        return numPage; // จำนวนหน้า
      },
    },
    _taxId: {
      get() {
        return this.getter_dataBusiness_profile["id_card_num"];
      },
    },
    // _emailProblem: {
    //   get() {
    //     return this.getter_dataBusiness_profile["email"];
    //   },
    // },
    _telProblem: {
      get() {
        return this.getter_dataBusiness_profile["tel_no"];
      },
    },
    _backgroudcolor: {
      get() {
        return this.backgroudcolor;
      },
    },
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    _SellerBranchId: {
      get() {
        return this.getter_dataBusiness_profile["branch_no"];
      },
    },
    _Companyname: {
      get() {
        if (this.$i18n.locale === "th") {
          return (
            this.getter_dataBusiness_profile["name_on_document_th"] ||
            this.getter_dataBusiness_profile["first_name_th"] +
              this.getter_dataBusiness_profile["last_name_th"] ||
            "-"
          );
        } else {
          return (
            this.getter_dataBusiness_profile["name_on_document_eng"] ||
            this.getter_dataBusiness_profile["first_name_eng"] +
              this.getter_dataBusiness_profile["last_name_eng"] ||
            "-"
          );
        }
      },
    },
    _HouseNo: {
      get() {
        return this.getter_dataBusiness_profile["address"]["house_no"];
      },
    },
    _RoomNo: {
      get() {
        return this.getter_dataBusiness_profile["address"]["room_no"];
      },
    },
    _Floor: {
      get() {
        return this.getter_dataBusiness_profile["address"]["floor"];
      },
    },
    _buildingName: {
      get() {
        return this.getter_dataBusiness_profile["address"]["building_name"];
      },
    },
    _mooBan: {
      get() {
        return this.getter_dataBusiness_profile["address"]["moo_ban"];
      },
    },
    _mooNo: {
      get() {
        return this.getter_dataBusiness_profile["address"]["moo_no"];
      },
    },
    _Soi: {
      get() {
        return this.getter_dataBusiness_profile["address"]["soi"];
      },
    },
    _Yaek: {
      get() {
        return this.getter_dataBusiness_profile["address"]["yaek"];
      },
    },

    _Street: {
      get() {
        return this.getter_dataBusiness_profile["address"]["street"];
      },
    },
    _Tambon: {
      get() {
        return this.getter_dataBusiness_profile["address"]["zipcode_tambon"];
      },
    },
    _Amphoe: {
      get() {
        return this.getter_dataBusiness_profile["address"]["zipcode_amphoe"];
      },
    },
    _Province: {
      get() {
        return this.getter_dataBusiness_profile["address"]["zipcode_province"];
      },
    },
    _Zipcode: {
      get() {
        return this.getter_dataBusiness_profile["address"]["zipcode_zipcode"];
      },
    },
  },
};
</script>

<style>
.table-stlye > .v-data-table th {
  padding: 1 0px !important;
  background-color: #2e3a4f !important;
  color: rgb(255, 255, 255) !important;
}
.th-stlye > .v-data-table th {
  border: 1px solid #3f4c63;
  text-align: center !important;
  border-collapse: collapse !important;
}
.th-first > .v-data-table th:first-child {
  border-radius: 5px 0 0 5px;
}

.th-last > .v-data-table th:last-child {
  border-radius: 0 5px 5px 0;
}
.swal-title {
  font-size: 1.6rem !important;
  font-family: "Prompt", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}
.swal-text {
  font-size: 14 !important;
  text-align: center;
  font-family: "Prompt", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}
.swal-button {
  font-size: 16 !important;
  font-family: "Prompt", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}
.swal-footer {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.noLogo {
  position: relative;
  height: 20px;
  width: 80px;
}
.logoPackage {
  position: relative;
  height: 20px;
  width: 80px;
  top: -17px;
  left: -23px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  background: linear-gradient(141.11deg, #1e90ff 0%, #000080 106.15%);
  &:before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    right: -8px;
    border-left: 8px solid #0e2faa;
    border-bottom: 10px solid transparent;
  }
  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    top: 10px;
    right: -8px;
    border-left: 8px solid #071290;
    border-top: 10px solid transparent;
  }
}
.textUsePackage {
  position: relative;
  left: 0px;
  top: -0.4em;
  font-size: 10px;
  color: #ffffff;
  font-weight: bold;
}
.bgPackage {
  //background: linear-gradient(to right, #F8B042, #D31638);
  background: linear-gradient(to right, #ae4a74, #8e65ab);
}
.cardPackage {
  border-radius: 15px;
  transition: 3s;
  cursor: pointer;
}
.cardPackage:hover {
  -webkit-filter: none;
  filter: none;
  animation: grow-and-shrink 2000ms;
}
.packageCardHead {
  background: #ffffff;
  border-radius: 15px;
  margin-top: 12px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: bold;
  padding-top: 6px;
}
.line-1 {
  height: 3px;
  background: #ffffff;
}
.packageCard {
  background: #ffffff;
  border-radius: 15px;
  border: solid;
  border-color: #e0e0e0;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 12px;
  font-size: 12px;
  transition: 3s;
  cursor: pointer;
}
.packageCard:hover {
  -webkit-filter: none;
  filter: none;
  animation: grow-and-shrink 2000ms;
}
.ellipsis {
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.test.prepaid {
  border-bottom: 6px solid #e0e0e0;
}
.scroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
.promotionPackage {
  border-radius: 15px;
  text-align: center;
  transition: 3s;
  cursor: pointer;
}
.promotionPackage:hover {
  -webkit-filter: none;
  filter: none;
  animation: grow-and-shrink 2000ms;
}
.rectangle {
  width: 360px;
  border-radius: 20px;
  background: #cfd8dc;
  border-color: #b0bec5;
  border-style: solid;
}
@keyframes grow-and-shrink {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
/* ========================== Responsive =============================== */
// หน้าจอที่ใหญ่กว่า
@media screen and (min-width: 1904px) {
  // Banner
  #banner {
    background: linear-gradient(75deg, #cbbddd, #84c9ef);
    z-index: 0;
    width: 86%;
    height: 92.5px;
    margin: auto;
    border-radius: 15px;
  }
  #banner .showHead {
    text-align: center;
  }
  #banner .btn-help {
    font-size: 16px;
    width: 60%;
    height: 40px;
  }
  // Code
  #code {
    width: 84%;
    margin: auto;
  }
  #code .mb_Sz_text {
    font-size: 18px;
  }
  #code .input {
    margin-left: 5px;
  }
  #code .btn-confirm {
    height: 40px;
    margin-left: 15px;
    text-align: left;
  }
  #code .btn-cancel {
    background-color: #f05c5a;
    width: 100%;
    height: 40px;
    margin-left: 10px;
  }
  // CardPackage
  #cardPackage {
    margin: auto;
  }
  #cardPackage .bgCard {
    background: linear-gradient(to bottom right, #30c3ea, #609cd4);
  }
  #cardPackage .btnContact {
    border-radius: 10px;
    background-color: #f05c5a;
    color: #ffffff;
    text-align: center;
    height: 50px;
    margin: auto;
    cursor: pointer;
    box-shadow: 1px 3px #c6c5c5;
  }
  #cardPackage .sheet {
    max-width: 1000px;
    margin: auto;
  }
  #cardPackage .sheetMore {
    max-width: 1100px;
    margin: auto;
  }
  #cardPackage .sheetMoreLessThree {
    max-width: 1000px;
    margin: auto;
  }
  #cardPackage .cardPackage {
    width: 309px;
    margin: left;
  }
  #cardPackage .cardDetail {
    width: 309px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .cardDetailLessThree {
    width: 309px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .mb_Sz_text {
    font-size: 20px;
    font-weight: bold;
    padding-left: 6px;
  }
  #cardPackage .detailStorage {
    color: #071290;
  }
  #cardPackage .star {
    width: 45px;
  }
}
// PC 1904px
@media screen and (max-width: 1904px) {
  // Banner
  #banner {
    background: linear-gradient(75deg, #cbbddd, #84c9ef);
    z-index: 0;
    width: 86%;
    height: 92.5px;
    margin: auto;
    border-radius: 15px;
  }
  #banner .btn-help {
    font-size: 16px;
    width: 100%;
    height: 40px;
  }
  // Code
  #code {
    width: 84%;
    margin: auto;
  }
  #code .mb_Sz_text {
    font-size: 18px;
  }
  #code .input {
    margin-left: 5px;
  }
  #code .btn-confirm {
    height: 40px;
    margin-left: 15px;
  }
  #code .btn-cancel {
    background-color: #f05c5a;
    width: 100%;
    height: 40px;
    margin-left: 10px;
  }
  // CardPackage
  #cardPackage {
    margin: auto;
  }
  #cardPackage .bgCard {
   background: linear-gradient(to bottom right, #30c3ea, #609cd4);
  }
  #cardPackage .btnContact {
    border-radius: 10px;
    background-color: #f05c5a;
    color: #ffffff;
    text-align: center;
    height: 50px;
    margin: auto;
    cursor: pointer;
    box-shadow: 1px 3px #c6c5c5;
  }
  #cardPackage .sheet {
    max-width: 1000px;
    margin: auto;
  }
  #cardPackage .sheetMore {
    max-width: 1100px;
    margin: auto;
  }
  #cardPackage .sheetMoreLessThree {
    max-width: 1000px;
    margin: auto;
  }
  #cardPackage .cardPackage {
    width: 309px;
    margin: left;
  }
  #cardPackage .cardDetail {
    width: 309px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .cardDetailLessThree {
    width: 309px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .mb_Sz_text {
    font-size: 20px;
    font-weight: bold;
    padding-left: 6px;
  }
  #cardPackage .mb_Sz_text_detail {
    font-size: 16px;
  }
  #cardPackage .detailStorage {
    font-size: 18px;
  }
  #cardPackage .star {
    width: 45px;
  }
}
// IPAD PRO
@media screen and (max-width: 1264px) {
  // Banner
  #banner {
    background: linear-gradient(75deg, #cbbddd, #84c9ef);
    z-index: 0;
    width: 89%;
    height: 92.5px;
    margin: auto;
    border-radius: 15px;
  }
  #banner .padding_page {
    width: 85%;
  }
  #banner .btn-help {
    font-size: 15px;
    width: 100%;
    height: 40px;
  }
  // Code
  #code {
    width: 88%;
    margin: auto;
  }
  #code .input {
    margin-left: 5px;
  }
  #code .mb_Sz_text {
    font-size: 18px;
  }
  #code .btn-confirm {
    height: 40px;
    margin-left: 15px;
  }
  #code .btn-cancel {
    background-color: #f05c5a;
    width: 130px;
    height: 40px;
    margin-left: 22px;
    margin-right: 22px;
    margin-left: 4px;
  }
  // CardPackage
  #cardPackage .sheet {
    width: 100%;
    margin: left;
  }
  #cardPackage .sheetMore {
    max-width: 1000px;
    margin: auto;
  }
  #cardPackage .cardPackage {
    width: 275px;
    margin: auto;
  }
  #cardPackage .cardDetail {
    width: 275px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .cardDetailLessThree {
    width: 275px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .mb_Sz_text {
    font-size: 16px;
    font-weight: bold;
    padding-left: 7px;
  }
  #cardPackage .star {
    width: 40px;
  }
  #cardPackage .star {
    width: 32px;
  }
}
// IPAD Air
@media screen and (max-width: 960px) {
  // Banner
  #banner {
    background: linear-gradient(75deg, #cbbddd, #84c9ef);
    z-index: 0;
    width: 86%;
    height: 92.5px;
    margin: auto;
    border-radius: 15px;
  }
  #banner .mb_Sz_text {
    font-size: 14px;
  }
  #banner .btn-help {
    font-size: 10px;
    margin: 5px;
    width: 105%;
    height: 40px;
  }
  // Code
  #code {
    width: 84%;
    margin: auto;
  }
  #code .input {
    margin-left: 5px;
  }
  #code .btn-confirm {
    height: 40px;
    margin-left: 15px;
  }
  #code .btn-cancel {
    background-color: #f05c5a;
    width: 100px;
    font-size: 14px;
    margin-left: 4px;
  }
  // CardPackage
  #cardPackage .cardPackage {
    width: 310px;
    margin: auto;
  }
  #cardPackage .cardDetail {
    width: 310px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .cardDetailLessThree {
    width: 310px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .mb_Sz_text {
    font-size: 20px;
    font-weight: bold;
    padding-left: 7px;
  }
}
// IPAD Mini
@media screen and (max-width: 800px) {
  // Banner
  #banner {
    background: linear-gradient(75deg, #cbbddd, #84c9ef);
    z-index: 0;
    width: 86%;
    height: 92.5px;
    margin: auto;
    border-radius: 15px;
  }
  #banner .mb_Sz_text {
    font-size: 14px;
  }
  #banner .btn-help {
    font-size: 10px;
    margin: 5px;
    width: 105%;
    height: 40px;
  }
  // Code
  #code {
    width: 84%;
    margin: auto;
  }
  #code .input {
    margin-left: 5px;
  }
  #code .btn-confirm {
    height: 40px;
    margin-left: 15px;
  }
  #code .btn-cancel {
    background-color: #f05c5a;
    width: 100px;
    font-size: 14px;
    margin-left: 4px;
  }
  // CardPackage
  #cardPackage .cardPackage {
    width: 285px;
    margin: auto;
  }
  #cardPackage .cardDetail {
    width: 285px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .cardDetailLessThree {
    width: 285px;
    border-radius: 15px;
    margin: 12px;
  }
  #cardPackage .mb_Sz_text {
    font-size: 20px;
    font-weight: bold;
    padding-left: 6px;
  }
}
// XR 600px
@media screen and (max-width: 600px) {
  // Banner
  #banner .mb_Sz_text {
    font-size: 14px;
  }
  #banner .btn-help {
    font-size: 13px;
    margin: 5px;
    width: 60%;
    height: 35px;
  }
  // Code
  #code .btn-confirm {
    height: 40px;
    margin-right: 5px;
  }
  #code .btn-cancel {
    width: 50px;
    margin-left: 4px;
  }
  #code .input {
    width: 50px;
  }
  // CardPackage
  #cardPackage .cardPackage {
    width: 260px;
    margin: auto;
  }
  #cardPackage .cardDetail {
    max-width: 309px;
    margin: auto;
  }
  #cardPackage .mb_Sz_text {
    font-size: 18px;
    font-weight: bold;
    padding-left: 5px;
  }
  #cardPackage .star {
    width: 36px;
  }
}
// 12 Pro , SE
@media screen and (max-width: 390px) {
  // Banner
  #banner .mb_Sz_text {
    font-size: 14px;
  }
  #banner .btn-help {
    font-size: 13px;
    margin: 5px;
    width: 70%;
    height: 35px;
  }
  // Code
  #code .btn-confirm {
    height: 40px;
    margin-right: 5px;
  }
  #code .btn-cancel {
    width: 100%;
  }
  #code .input {
    width: 50px;
  }
  // CardPackage
  #cardPackage .cardPackage {
    width: 242px;
    margin: auto;
  }
  #cardPackage .cardDetail {
    width: 309px;
    margin: auto;
  }
  #cardPackage .mb_Sz_text {
    font-size: 20px;
    font-weight: bold;
    padding-left: 5px;
  }
  #cardPackage .star {
    width: 32px;
  }
}
</style>